module.exports = __webpack_public_path__ + "img/alumni-information.78b1511e.svg";